import { useState } from 'react'
import { useAuth } from 'ict24h-themes-react'
import requestErrorHandler from '../../../utils/request-error-handler'
import commonRequestHandler from '../../../utils/common-request-handler'
import { checkRole } from '../list-role.service'
import { ListRoleCode } from '../constants/config.list-role'

type RequestFailType = 'SERVER' | 'RESOURCE' | 'OTHER'

type Params = {
  code: ListRoleCode
  onFinish?: (_res: boolean) => void
  onFail?: (_failType: RequestFailType) => void
  customRequestHandler?: boolean
}

const useCheckRole = (params: Params) => {
  const { token } = useAuth()

  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<boolean | null>(null)

  const handleCheckRole = async (localHandler: Partial<Params> = {}) => {
    const code = localHandler?.code || params.code
    const onFinish = localHandler?.onFinish || params.onFinish
    const onFail = localHandler?.onFail || params.onFail
    const customRequestHandler =
      localHandler?.customRequestHandler ?? params.customRequestHandler

    const requestHandler = customRequestHandler
      ? requestErrorHandler
      : commonRequestHandler

    setLoading(true)
    const res = await checkRole(token, { code })
    setLoading(false)
    if (!res) {
      if (typeof onFail === 'function') onFail('OTHER')
      return
    }
    requestHandler({
      status: res?.status,
      action: 'get',
      onSuccess: () => {
        setResult(res.data)
        if (typeof onFinish === 'function') onFinish(res.data)
      },
      onResourceFail: () => {
        if (typeof onFail === 'function') onFail('RESOURCE')
      },
      onServerFail: () => {
        if (typeof onFail === 'function') onFail('SERVER')
      },
    })
  }

  return {
    loading,
    handleCheckRole,
    result,
  }
}

export default useCheckRole
